import { Injectable, computed, effect, signal } from '@angular/core';

export type ChromeTheme = 'dark' | 'light';

const STORAGE_KEY = 'pento-chrome-theme';

@Injectable({ providedIn: 'root' })
export class ChromeThemeService {
  private readonly themeSignal = signal<ChromeTheme>(this.loadTheme());

  readonly theme = this.themeSignal.asReadonly();
  readonly isDark = computed(() => this.themeSignal() === 'dark');
  readonly isLight = computed(() => this.themeSignal() === 'light');

  constructor() {
    this.applyBodyClass(this.themeSignal());
    effect(() => this.applyBodyClass(this.themeSignal()));
  }

  setTheme(theme: ChromeTheme): void {
    this.themeSignal.set(theme);
    if (typeof localStorage !== 'undefined') {
      localStorage.setItem(STORAGE_KEY, theme);
    }
  }

  toggleTheme(): void {
    this.setTheme(this.isDark() ? 'light' : 'dark');
  }

  private applyBodyClass(theme: ChromeTheme): void {
    if (typeof document === 'undefined') return;
    document.body.classList.toggle('chrome-dark', theme === 'dark');
    document.body.classList.toggle('chrome-light', theme === 'light');
  }

  private loadTheme(): ChromeTheme {
    if (typeof localStorage === 'undefined') {
      return 'dark';
    }
    return localStorage.getItem(STORAGE_KEY) === 'light' ? 'light' : 'dark';
  }
}
